import { useTranslation } from 'next-i18next';
import { useConductricsSelection } from '@dx-ui/framework-conductrics';

const PATTERN_BY_CHOICE = {
  // Default — current experience: “Forgot your info?” above Sign In CTA
  A: { placement: 'aboveSignIn', text: 'info', goal: 'g-forgot-your-info-above-signin-cta' },
  // Variant 1 — “Forgot your info?” below Sign In CTA
  B: { placement: 'belowSignIn', text: 'info', goal: 'g-forgot-your-info-below-signin-cta' },
  // Variant 2 — “Forgot your password?” above Sign In CTA
  C: {
    placement: 'aboveSignIn',
    text: 'password',
    goal: 'g-forgot-your-password-above-signin-cta',
  },
  // Variant 3 — “Forgot your password?” below Sign In CTA
  D: {
    placement: 'belowSignIn',
    text: 'password',
    goal: 'g-forgot-your-password-below-signin-cta',
  },
  // Variant 4 — “Forgot your Hilton Honors number?” above Sign In CTA
  E: {
    placement: 'aboveSignIn',
    text: 'hiltonHonorsNumber',
    goal: 'g-forgot-your-hhnumber-above-signin-cta',
  },
  // Variant 5 — “Forgot your Hilton Honors number?” below Sign In CTA
  F: {
    placement: 'belowSignIn',
    text: 'hiltonHonorsNumber',
    goal: 'g-forgot-your-hhnumber-below-signin-cta',
  },
};

export const useForgotInfoLinkCopyTest = () => {
  const { t } = useTranslation('osc-login');
  const { isLoaded, selection } = useConductricsSelection('a-auth-720');
  const { placement, text, goal } =
    isLoaded && selection?.choice
      ? PATTERN_BY_CHOICE[selection.choice.toUpperCase() as keyof typeof PATTERN_BY_CHOICE]
      : PATTERN_BY_CHOICE.A;
  const linkCopy =
    text === 'password'
      ? t('forgotPassword')
      : text === 'hiltonHonorsNumber'
        ? t('forgotHiltonHonorsNumber')
        : t('forgotInfo');

  return {
    isForgotCopyTestLoaded: isLoaded,
    isForgotCopyLinkCopy: linkCopy,
    isForgotCopyLinkPlacement: placement,
    isForgotCopyTestGoal: goal,
  };
};
